<template>
  <div id="home-index">
    <!-- Qrcode-modal -->
    <div class="popup" v-if="isPopup">
      <div :item="item"  class="popup-wrapper">
        <header><img src="@/assets/img/logo.png" alt=""></header>
        <div class="times-icon" @click="closeQrcode"><img src="@/assets/img/times.png" alt=""></div>
        <div class="popup-content">
          <div class="brand"><img :src="`./assets/img/${item.brandName}.png`" alt=""></div>
          <h2>請出示會員條碼</h2>
          <div class="qrcode"><img :src="`${item.memberQrcode}`" alt=""></div>
          <h3>{{ item.memberCode }}</h3>
        </div>
      </div>
      <div class="popup-bg"></div>
    </div>
    <header><img src="@/assets/img/logo.png" alt=""></header>
    <div class="container">
      <div class="wrapper">
        <!-- <div class="times-icon"><img src="/assets/img/times.png" alt=""></div> -->
        <!-- point area -->
        <div class="text-area">
          <h1>累積點數</h1>
          <h2 class="font-r">{{ formatPrice(cardList.memberPoints) }}</h2>
          <div class="point-card">
            <div class="point-box">
              <div class="point-title">{{ getYear }}/12/31 到期點數</div>
              <h2 class="font-r">{{ formatPrice(cardList.nowYearExpirePoint) }}</h2>
            </div>
            <div class="point-box">
              <div class="point-title">{{ getYear+1 }}/12/31 到期點數</div>
              <h2 class="font-r">{{ formatPrice(cardList.nextYearExpirePoint) }}</h2>
            </div>
          </div>
          <p>（1點可折抵1元，共可折抵{{ cardList.memberPoints }}元）</p>
            <!-- <p>LINE僅供查詢點數，各品牌兌點方式依各店櫃公告為主。</p>
            <p>全新會員制度將於明年初上線，敬請期待！</p> -->
        </div>
        <!-- 會員卡 -->
        <swiper class="swiper" id="card-list" ref="mySwiper" :options="swiperOption" @slide-change="slideChange">
          <swiper-slide v-for="item in newBrands" class="card-area swiper-only" :item="item" :key="item.id">
            <div class="member-card">
              <div class="title-area">
                <img :src="`./assets/img/circle_${item.brandName}.png`" alt="">
                <div class="name-tag">
                  <p>{{ user.name }}</p>
                  <p>{{ item.memberCode }}</p>
                </div>
                <div class="member-code" @click="openQrcode(item)">
                  <img src="@/assets/img/qrcode.png" alt="">
                  <p>會員條碼</p>
                </div>
              </div>
              <div class="card-point">
                <h2 :class="item.status">{{ item.memberLevel }}<img :src="`./assets/img/star_${item.status}.png`" alt=""></h2>
                <!-- next status hint -->
                <p v-if="item.threshold[`A0${item.rank+1}`] != null">離{{ item.nextLevel }}還差{{ formatPrice(item.threshold[`A0${item.rank+1}`] - item.totalAmount) }}元</p>
                <p v-else>-</p>
                <!-- next status total -->
                <p class="font-r point-status">{{ formatPrice(item.totalAmount) }}
                  <span v-if="item.threshold[item.displayType] !== null && item.threshold[item.displayType] !== 0 ">/ {{ formatPrice(item.threshold[item.displayType]) }}元</span>
                  <span v-else-if="item.threshold[item.displayType] == null && item.threshold[item.displayType] !== 0 "></span>
                  <span v-else>/ 不限金額升等</span>
                <!-- progresss bar -->
                <div v-if="item.displayType == 'A05'" class="bar" :class="`${item.status}_bar`" :style="`--percent: 1`"></div>
                <div v-else-if="item.threshold[`A0${item.rank + 1}`] != null && item.threshold[`A0${item.rank + 1}`] > 0" class="bar" :class="`${item.status}_bar`" :style="`--percent: ${ (item.totalAmount / item.threshold[`A0${item.rank + 1}`]) }`"></div>
                <div v-else  class="bar" :class="`${item.status}_bar`" :style="`--percent: 1`"></div>
              
                <p>會員效期 {{ item.memberExpire }}</p>
              </div>
            </div>
          </swiper-slide>

          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>

        <div class="link-area">
          <div class="link-btn" @click="$router.push({ name: 'Record', params: {
            memberPoints: cardList.memberPoints,
            nowYearExpirePoint: cardList.nowYearExpirePoint,
            nextYearExpirePoint: cardList.nextYearExpirePoint,
            nowYear: getYear,
            nextYear: (getYear + 1)
          }})"><img src="@/assets/img/icon_trade.png" alt="">
            <p>交易紀錄</p>
          </div>
          <div class="link-btn" @click="toRealUrl('/Ecard/mycoupon')"><img src="@/assets/img/icon_coupon.png" alt="">
            <p>我的優惠券</p>
          </div>
          <div class="link-btn" @click="toRealUrl('https://liff.line.me/1656334484-VXzOkjW8?lf=1656334484-VXzOkjW8&seq=df1EQxFqBm3')"><img src="@/assets/img/icon_plan.png" alt="">
            <p>會員制度</p>
          </div>
          <div class="link-btn" @click="toRealUrl('https://www.starlike.com.tw/bonus-points/')"><img src="@/assets/img/icon_points.png" alt="">
            <p>點數活動</p>
          </div>
          <div class="link-btn" @click="toRealUrl('/OnlineBooking/booking_index')"><img src="@/assets/img/icon_reserve.png" alt="">
            <p>預約活動</p>
          </div>
          <div class="link-btn" @click="toUrl('edit')"><img src="@/assets/img/icon_revise.png" alt="">
            <p>資料修改</p>
          </div>
          <div class="link-btn"><img src="@/assets/img/icon_invoice.png" alt="">
            <p class="inactivate">發票登入</p>
          </div>
          <div class="link-btn"><img src="@/assets/img/icon_warranty.png" alt="">
            <p class="inactivate">商品保固卡</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'homeIndex',
  components: {

  },
  created() {
    this.user = this.$root.$data.userData;
  },
  data() {
    return {
      item:null,
      isPopup: false,
      cardList: {},
      user: {
          name: "",
          brands: [
            {
              "displayType": "",
              "brandName": "",
              "memberLevel": "",
              "nextLevel": "",
              "memberCode": "",
              "memberQrcode": "",
              "memberExpire": "",
              "totalAmount": 0,
              "status": "",
              "memberPoints": 0,
              "nowYearExpirePoint": 0,
              "nextYearExpirePoint": "-"
            }
          ],
          rules: [
            {
              brand: "",
              threshold: {
                "A01": null,
                "A02": null,
                "A03": null,
                "A04": null,
              }
            }
          ]
      },
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        centeredSlides: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      }
    }
  },
  mounted() {
    this.cardList  = this.user.brands[this.$refs.mySwiper.$swiper.activeIndex];
  },
  computed: {
    getYear: function() {
      let Today = new Date();
      return Today.getFullYear()
    },
    newBrands() {
      let newBrands = JSON.parse(JSON.stringify(this.user.brands));
      newBrands.forEach(brand => {
        let threshold = this.user.rules.find(rule => rule.brand === brand.brandName).threshold;
        brand.threshold = threshold;
        let { displayType: nowLevel, brandName } = brand;
        // let rank = 0;
        let rank = Number.parseInt(nowLevel.split('A')[1])-1;
        brand.rank = rank;
      })
      return newBrands;
    }
  },
  methods: {
    formatPrice: function (val) {
      if(val === '-'){
        return '-';
      }
      let formatNUmber = new Intl.NumberFormat('en-US')
      return formatNUmber.format(val)
    },
    openQrcode: function (item) {
      this.isPopup = true;
      this.item = item;
    },
    closeQrcode: function () {  
      this.isPopup = false
    },
        // init: function () {
        //   axios.post("https://sam.dev.coolbe.com.tw/api/client/member/info", 
        //   {"uid": "Uc9cd08f724dc92372732dfacd85b0731"})
        //         .then(function (res) {
        //           this._data.user = res.data.data.user;
        //           this.slideChange()
        //          })
        //         .catch(function(error) {
        // },
    slideChange: function () {
      let idx = this.$refs.mySwiper.$swiper.activeIndex;
      this.cardList  = this.user.brands[idx];
    },
    toUrl(val, params = {}) {
      this.$router.push({ path:`/${ val }`, params: `/${ params }` });
    },
    toRealUrl(val) {
      window.location.href = val;
    }
  },
};
</script>

<style scoped>
/***** 會員卡主頁 *****/
/* #home-index{
  max-width: 540px;
} */
.status-color{
    color: var(--bronze);
}
header {
    position: relative;
}
.wrapper .times-icon{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: absolute;
    right: 3%;
    top: 0;
    height: 72px;
}
.wrapper .times-icon img{
    height: 30px;
    width: 30px;
    display: block;
    margin: auto 0;
}
.text-area {
    margin-bottom: 30px;
    padding: 0 4%;
}
    .text-area h1 {
        font-size: 18px;
        font-weight: 500;
        color: #000000;
    }
      .text-area h2 {
        font-size: 40px;
        font-weight: bold;
        margin: 3% 0;
    }
      .text-area p {
          font-size: 13px;
          color: #7F7F80;
      }
.text-area .point-card {
    display: flex;
    display: -webkit-flex; 
}
.text-area .point-card .point-box{
    width: 50%;
    background:url(../assets/img/point-box.png) no-repeat left;
    background-size: 100%;
    margin: 0 2%; 
}
.text-area .point-card .point-box .point-title{
    font-weight: 400;
    font-size: 13px;
    margin: 0;
    padding: 10px 0 5px 0 ;
    color: #4C4C4D; 
}
.text-area .point-card .point-box h2{
    font-size: 22px;
    margin: 10px 0 10px 0;
    font-weight: bold; 
}
@media screen and (max-width: 280px) {
    .text-area .point-card .point-box{
        padding: 4% 0;}
    .text-area .point-card .point-box .point-title {
        font-size: 12px;
        padding: 0 0 10px 0;}
    .text-area .point-card .point-box h2 {
        font-size: 18px;
        margin: 0;}}
@media screen and (min-width: 400px) {
    .text-area .point-card .point-box{
        padding: 4% 0;}
    .text-area .point-card .point-box .point-title {
        font-size: 15px;
        padding: 5px 0 8px 0;}}
@media screen and (min-width: 540px) {
    .text-area .point-card .point-box{
        padding: 4% 0;}
    .text-area .point-card .point-box .point-title {
        font-size: 21px;
        padding: 0 0 15px 0;}
    .text-area .point-card .point-box h2 {
        font-size: 30px;
        margin: 2% 0 3% 0;}}
.link-area {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    padding: 0 6%;
    margin-bottom: 30px;
    padding: 5px 6% 30px 6%;
}
.link-area .link-btn {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
    margin: 3% 0;
}
.link-area .link-btn img{
    width: 42%;
}
.link-area .link-btn p{
    font-size: 14px;
    color: #100316;
    margin: 2% 0;
}
.link-area .link-btn p.inactivate {
    color: #B7B3B9;
}
@media screen and (max-width: 280px) {
    .link-area .link-btn p {
        font-size: 12px;}}
/* member-card */
.bronze{
    color: #E6875C;
}
.silver{
    color: #CCCCCC;
}
.gold{
    color: #E6A82E;
}
.diamond{
    color: #CCF6FF;
}

.card-area {
    background: linear-gradient(0.38turn, #4D4D4D, #141414);
    border-radius: 15px;
    padding: 4% 5%;
    width: 70%;
    text-align: left;
    box-shadow: 0px 10px 17px -4px rgba(35, 35, 35, 0.60);
 }
 @media screen and (max-width: 320px) {
    .card-area {
        width: 80%;
        padding: 4% 4%;}}
.member-card .title-area  {
    display: flex;
    display: -webkit-flex;
    vertical-align: middle;
    position: relative;
}
.member-card .title-area .name-tag{
    color: #FFFFFF;
    margin: auto 0 auto 4%;
}
.member-card .title-area .name-tag p{
    margin: 3% 0;
    font-size: 13px;
}
.member-card .title-area img{
    width: 52px;
    height: 52px;
}
.member-card .title-area .member-code {
    display: flex;
    display: -webkit-flex;
    background-color: #000000;
    margin: auto 0;
    border-radius: 50px ;
    padding: 1.5% 3%;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    border: 3px solid #4C4C4D;
}
.member-card .title-area .member-code img{
    width: 26px;
    height: 26px;
}
.member-card .title-area .member-code p{
    color: #FFFFFF;
    margin: 0;
    line-height: 26px;
    font-size: 12px;
}
.member-card .card-point h2{
    font-size: 22px;
    margin: 2% 0;
    position: relative;
    font-weight: 500;
}
.member-card .card-point h2 img{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
}
.member-card .card-point p{
    color: #FFFFFF;
    margin: 0;
    font-size: 12px;
}
.member-card .card-point .point-status {
    font-size: 24px;
    font-weight: 500;
    margin: 1% 0;
}
.member-card .card-point .point-status span{
    font-size: 14px;
    font-weight: 500;
    margin-left: 2%;
}
/* progress-bar */
.member-card .card-point .bar {
    height: 10px; 
    width: 100%;
    background-color: #000000;
    margin: 3% 0;
    border-radius: 50px;
}
.member-card .card-point .bar::before {
    content: '';
    display: block;
    /* width: calc(100% * var(--percent) / 50000); */
    width: calc(100% * var(--percent));
    height: 10px;
    border-radius: 50px;
}
.bronze_bar::before {
    background: linear-gradient(0.25turn,#CC7852, #DCA084);
}
.silver_bar::before {
    background: linear-gradient(0.25turn,#808080, #CCCCCC);
}
.gold_bar::before {
    background: linear-gradient(0.25turn,#B37700, #F2B230);
}
.diamond_bar::before {
    background: linear-gradient(0.25turn,#29AACC, #A1E3E6);
}
/* swiper-card */
.swiper-pagination {
    position: unset;
    margin: 4% 0;
}
.swiper-pagination-bullet-active {
    background: #100316;
}
/* Qrcode modal*/
.popup-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: 10;
    top: 0;
}
.popup-wrapper{
    max-width: 540px;
    text-align: center;
    /* overflow: hidden; */
    width: 100%;
    z-index: 20;
    position: absolute;
    left: 50%;
    top: 0;
    -webkit-transform: translate(-50%, 0);
    -ms-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
    z-index: 11;
}
.popup-wrapper .times-icon{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: absolute;
    right: 3%;
    top: 0;
    height: 72px;
}
.popup-wrapper .times-icon img{
    height: 30px;
    width: 30px;
    display: block;
    margin: auto 0;
}
.popup-content {
    padding: 0 8%;
}
.popup-wrapper .brand {
    background-color: #000;
    height: 180px;
    border-radius: 15px;
    margin: 10% 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.popup-wrapper .brand img{
    width: 40%;
}
.popup-wrapper .qrcode img{
    width: 55%;
}
.popup-wrapper  h2 {
    font-size: 14px;
}
.popup-wrapper h3 {
    margin: 10px 0 0 0 ;
    font-size: 12px;
}
</style>